import {
  sendbirdSelectors,
  useSendbirdStateContext,
} from '@sendbird/uikit-react';
import SendbirdApp from '@sendbird/uikit-react/App';

import '@sendbird/uikit-react/dist/index.css';
import { useAppSelector } from 'src/app/store';
import { LoadingIndicator } from 'src/common/primitives/LoadingIndicator';

import { useAuth } from '../auth/useAuth';

export function Chat() {
  const auth = useAuth();

  const { sendbirdAccessToken, chatError } = useAppSelector(
    (state) => state.chat
  );

  const globalStore = useSendbirdStateContext();
  const sdkInstance = sendbirdSelectors.getSdk(globalStore);
  const userId = sdkInstance?.currentUser?.userId;

  const bambiColorSet = {
    '--sendbird-light-primary-500': '#2b6764',
    '--sendbird-light-primary-400': '#3a8a85',
    '--sendbird-light-primary-300': '#1C3456',
    '--sendbird-light-primary-200': '#6dbdb8',
    '--sendbird-light-primary-100': '#b6dedb',
  };

  if (chatError) {
    return (
      <div className="flex min-h-[80vh] flex-col items-center justify-center">
        <p>There was an error loading chat. Please refresh the page.</p>
        <p>If this error persists, please contact support</p>
      </div>
    );
  }

  if (
    !auth.currentMembership?.id ||
    !auth.sendbirdAppId ||
    !sendbirdAccessToken ||
    !userId
  ) {
    return (
      <div className="flex min-h-[80vh] items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="mx-[-2rem] h-[90vh] w-[100vw]">
      <SendbirdApp
        appId={auth.sendbirdAppId}
        userId={auth.currentMembership.id}
        accessToken={sendbirdAccessToken}
        colorSet={bambiColorSet}
      />
    </div>
  );
}
